var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Tile } from '@timeflies/tilemap-utils';
import React from 'react';
import { Container } from 'react-pixi-fiber';
import { TilemapTile } from './tilemap-tile';
export var TilemapLayer = React.memo(function (_a) {
    var mapSheet = _a.mapSheet, mapTexture = _a.mapTexture, onTileMouseHover = _a.onTileMouseHover, layer = _a.layer, _b = _a.interactive, interactive = _b === void 0 ? false : _b, _c = _a.characters, characters = _c === void 0 ? {} : _c;
    var layerData = layer.data;
    return (React.createElement(Container, null, layerData.flatMap(function (id, index) {
        var _a;
        var pos = Tile.getTilePositionFromIndex(index, mapSheet);
        var children = (_a = characters[pos.id]) !== null && _a !== void 0 ? _a : [];
        return __spreadArray(__spreadArray([], children), [
            React.createElement(TilemapTile, { key: layer.name + ':' + index, id: id, index: index, mapSheet: mapSheet, mapTexture: mapTexture, onTileMouseHover: onTileMouseHover, layer: layer, interactive: interactive })
        ]);
    })));
});
